import React, {ReactNode} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {calculateRemSize, color, display, gridG, listUnStyled, m, onDesktop, p, pv, underline, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ISiteMapLink} from "../interfaces/ISiteMapLink";
import {ISiteMapLinkWithOfferCount} from "../interfaces/ISiteMapLinkWithOfferCount";

interface IProps {
    links: (ISiteMapLink & Partial<ISiteMapLinkWithOfferCount>)[];
    textPrefix?: ReactNode;
    target?: "_self" | "_blank";
    variant?: Parameters<typeof Text>[0]["variant"];
    gap?: Parameters<typeof calculateRemSize>[0];
}

export const siteMapLinkDefinedPrefixes = {
    bullet: `${String.fromCharCode(8226)} `
};

export const SiteMapLinkList = (props: IProps) => {
    const theme = useTheme();

    return (
        <ul css={[listWrapperStyle, gridG(props.gap ?? 3), p(2, 3)]}>
            {props.links.map((link) => (
                <Text as="li" variant={props.variant || "headline_6"} key={`${link.href}_${link.text}`}>
                    <a href={link.href} css={[linkStyle, pv(1)]} target={props.target}>
                        {props.textPrefix}
                        <span className="link">{link.text}</span>
                        {link?.offerCount ? <span css={[color(theme.colors.gray[600])]}> ({link.offerCount})</span> : null}
                    </a>
                </Text>
            ))}
        </ul>
    );
};

const listWrapperStyle = css`
    ${listUnStyled};
    ${m(0)};
    display: grid;

    ${onDesktop(css`
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto;
    `)};
`;

const linkStyle = (theme: Theme) => css`
    ${display("inline-block")};
    ${w100};

    &:hover > .link,
    &:focus > .link,
    &:active > .link {
        color: ${theme.colors.secondary};
        ${underline};
    }
`;
import React, {ReactNode} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {calculateRemSize, color, display, gridG, listUnStyled, m, onDesktop, p, pv, underline, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ISiteMapLink} from "../interfaces/ISiteMapLink";
import {ISiteMapLinkWithOfferCount} from "../interfaces/ISiteMapLinkWithOfferCount";

interface IProps {
    links: (ISiteMapLink & Partial<ISiteMapLinkWithOfferCount>)[];
    textPrefix?: ReactNode;
    target?: "_self" | "_blank";
    variant?: Parameters<typeof Text>[0]["variant"];
    gap?: Parameters<typeof calculateRemSize>[0];
}

export const siteMapLinkDefinedPrefixes = {
    bullet: `${String.fromCharCode(8226)} `
};

export const SiteMapLinkList = (props: IProps) => {
    const theme = useTheme();

    return (
        <ul css={[listWrapperStyle, gridG(props.gap ?? 3), p(2, 3)]}>
            {props.links.map((link) => (
                <Text as="li" variant={props.variant || "headline_6"} key={`${link.href}_${link.text}`}>
                    <a href={link.href} css={[linkStyle, pv(1)]} target={props.target}>
                        {props.textPrefix}
                        <span className="link">{link.text}</span>
                        {link?.offerCount ? <span css={[color(theme.colors.gray[600])]}> ({link.offerCount})</span> : null}
                    </a>
                </Text>
            ))}
        </ul>
    );
};

const listWrapperStyle = css`
    ${listUnStyled};
    ${m(0)};
    display: grid;

    ${onDesktop(css`
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto;
    `)};
`;

const linkStyle = (theme: Theme) => css`
    ${display("inline-block")};
    ${w100};

    &:hover > .link,
    &:focus > .link,
    &:active > .link {
        color: ${theme.colors.secondary};
        ${underline};
    }
`;
